import { useState } from 'react'
import DashboardLayout from '../../common/DashboardLayout'
import { Icon1, Icon2, User4, course04 } from '../../imagepath'
import { Link } from 'react-router-dom'
import TeacherServices from "../../../services/TeacherServices";
import { useNavigate } from "react-router-dom";
import {showErrorAlerts,showsuccessAlert} from '../../../services/AlertService';

const AddSchoolTeacher = () => {

    const [isClassAdded, setIsClassAdded] = useState([false]);
    const navigate = useNavigate();
    const toggleClass = (index) => {
      const updatedClasses = [...isClassAdded];
      updatedClasses[index] = !updatedClasses[index];
      setIsClassAdded(updatedClasses);
    };

    const [form, setForm] = useState({ firstName: '', lastName: '', email: '' });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        // Combine firstName and lastName into name
        const fullName = `${form.firstName.trim()} ${form.lastName.trim()}`.trim();
        const response = await TeacherServices.addSchoolTeacher(fullName, form.email);
        console.log(response,'get response');
        if(response && response.message){
          showsuccessAlert(response.message);
            setForm({ firstName: "", lastName: "", email: "" });
            navigate('/my-teachers');
        }
      } catch (err) {
        // alert("Failure");
      }
  };
    const userobj = JSON.parse(localStorage.getItem('user') || '{}');
    
    return (
        <DashboardLayout 
            role={1} 
            userType={userobj?.type}
            activeMenu="Add Teacher"
            layoutType="topnav"
        >
                                {/* Dashboard Grid */}
                                <div className="row justify-content-center">
                                <form onSubmit={handleSubmit}>
                                <div className="input-block">
                      <label className="form-control-label">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter first name"
                        value={form.firstName}
                        onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter last name"
                        value={form.lastName}
                        onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                        required
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                      />
                    </div>

                    <div className="d-grid">
                      <button
                        className="btn btn-start"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                                </div>
        </DashboardLayout>
    )
}

export default AddSchoolTeacher
